import module from 'empresa/module.js'
import template from './template.html'
import {orderBy} from 'lodash'

export class EmpresaClientesListaComponent {
  empresaId
  data
  editable = false

  constructor (EmpresaClientes) {
    this.EmpresaClientesService = EmpresaClientes
  }

  $onInit () {
    this.promise = this.EmpresaClientesService.get(this.empresaId)
      .then((response) => {
        this.editable = response.data.editable
        this.data = response.data.clientes.filter((item) => {
          if (item.activo) {
            return item
          }
        })
        this.data = orderBy(this.data, ['nombre'])
      })
  }

  eliminar (data) {
    this.data = this.data.filter((item) => {
      return item.cliente_id !== data.cliente_id
    })
  }
}

module.component('empresaClientesLista', {
  controller: EmpresaClientesListaComponent,
  template,
  bindings: {
    empresaId: '<',
  },
})



// WEBPACK FOOTER //
// ./src/empresa/components/clientes/lista/component.js